import Resource from '@/api/resources/Resource'

class CaseClinicalDataService extends Resource {
    async findById(labId, casId) {
        return this.axios.get(`/laboratories/${labId}/cases/${casId}/clinicalData`)
            .then(response => response.data)
    }

    async update(labId, casId, clob) {
        return this.axios.put(`/laboratories/${labId}/cases/${casId}/clinicalData`, clob)
            .then(response => response.data)
    }
}

export default new CaseClinicalDataService()
